import { Avatar } from 'antd';
import React, { useState } from 'react';
import { HeaderConfig, MenuItem } from '../..';
import './style.scss';
interface Prop {
  headerConfig: HeaderConfig;
  onRenderItemHeader?: (item: MenuItem, handleTab?: any) => React.ReactNode;
  onRenderMenuCreateItem?: () => React.ReactNode;
}

const Header = (props: Prop) => {
  const {
    headerConfig: { leftConfig, userImg, profileComponent },
    onRenderItemHeader,
    onRenderMenuCreateItem,
  } = props;
  const [isActive, setIsActive] = useState(leftConfig[0].key);
  const handleTab = (tab: string) => {
    setIsActive(tab);
  };
  return (
    <div className="header-container">
      <div className="header-left">
        <div>
          <svg
            width="28"
            height="32"
            viewBox="0 0 28 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.7987 28.5769C9.74147 28.5769 7.85595 27.903 6.3972 26.7885C4.5718 25.3935 3.41196 23.3049 3.41196 20.9701C3.41196 19.5643 3.83094 18.246 4.56404 17.1164C4.56404 17.1164 11.7695 5.79868 11.7964 5.75319L14.6099 10.1643L14.6092 10.1647L14.6115 10.1679L19.0294 17.1121C19.0299 17.1143 19.031 17.1164 19.0317 17.1181C19.7653 18.2481 20.186 19.5643 20.186 20.9701C20.186 25.1714 16.431 28.5769 11.7987 28.5769ZM15.5942 3.36054H22.7504L18.1664 10.5615L16.6044 8.10657L13.6986 3.54265C14.1169 3.41307 14.686 3.36054 15.5942 3.36054ZM19.8273 13.1714L27.7372 0.75H15.5317C12.1284 0.831635 11.2367 1.43969 9.94006 3.47292C9.94006 3.47292 2.09319 15.8014 2.08896 15.8084C1.11471 17.3197 0.544922 19.0936 0.544922 20.9708C0.544922 24.686 2.73391 27.937 6.00624 29.7223C7.69737 30.6448 9.68134 31.1773 11.7987 31.1773C18.0144 31.1773 23.0532 26.6074 23.0532 20.9708C23.0532 19.0395 22.4601 17.2342 21.4326 15.6945L19.8273 13.1714ZM18.0428 20.9706C18.0428 24.0979 15.2472 26.6333 11.7991 26.6333C8.35042 26.6333 5.55483 24.0979 5.55483 20.9706C5.55483 17.8429 8.35042 15.3074 11.7991 15.3074C15.2472 15.3074 18.0428 17.8429 18.0428 20.9706Z"
              fill="white"
            />
          </svg>
        </div>
        <div className="header-wrap">
          <p className="header-title">OSCAR</p>
          <p className="header-description">
            Online System for Civil Activity Request
          </p>
        </div>
        {leftConfig &&
          leftConfig.map((u) => {
            return (
              <div
                className={`header-item ${
                  isActive === u.key ? 'tab-active' : ''
                }`}
                onClick={() => {
                  u?.component || u?.link?.includes('https://')
                    ? null
                    : handleTab(u.key);
                }}
                key={u.key}
              >
                {onRenderItemHeader?.(u, handleTab)}
              </div>
            );
          })}
      </div>
      <div className="header-right">
        <div style={{ marginRight: '40px', display: 'flex' }}>
          {onRenderMenuCreateItem?.()}
        </div>
        <div style={{ display: 'flex' }}>
          <svg
            width="19"
            height="20"
            viewBox="0 0 19 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 15.625H18.0625C18.5812 15.625 19 15.2063 19 14.6875V0.9375C19 0.41875 18.5812 0 18.0625 0H4C2.275 0 0.875 1.4 0.875 3.125V16.875C0.875 18.6 2.275 20 4 20H18.0625C18.5812 20 19 19.5812 19 19.0625C19 18.5438 18.5812 18.125 18.0625 18.125H4C3.3125 18.125 2.75 17.5625 2.75 16.875C2.75 16.1875 3.3125 15.625 4 15.625ZM10.6 12.5375C10.425 12.7125 10.1812 12.8125 9.9375 12.8125C9.69375 12.8125 9.45 12.7125 9.275 12.5375C9.1 12.3625 9 12.125 9 11.875C9 11.6313 9.1 11.3875 9.275 11.2125C9.625 10.8625 10.25 10.8625 10.6 11.2125C10.775 11.3875 10.875 11.6313 10.875 11.875C10.875 12.125 10.775 12.3625 10.6 12.5375ZM8.13125 3.46875C8.76875 2.9375 9.6125 2.7125 10.4375 2.85625C11.575 3.05625 12.5063 3.9875 12.7063 5.125C12.9125 6.31875 12.35 7.50625 11.2937 8.0875C11.0375 8.23125 10.875 8.55 10.875 8.9125V9.0625C10.875 9.58125 10.4563 10 9.9375 10C9.41875 10 9 9.58125 9 9.0625V8.9125C9 7.8625 9.53125 6.91875 10.3875 6.45C10.6625 6.3 10.9437 5.94375 10.8562 5.45C10.7937 5.08125 10.4813 4.76875 10.1188 4.70625C9.825 4.65 9.55 4.725 9.3375 4.90625C9.125 5.0875 9 5.35 9 5.625C9 6.14375 8.58125 6.5625 8.0625 6.5625C7.54375 6.5625 7.125 6.14375 7.125 5.625C7.125 4.79375 7.49375 4.00625 8.13125 3.46875Z"
              fill="white"
            />
          </svg>
        </div>
        <div>
          {profileComponent ? (
            profileComponent
          ) : (
            <Avatar style={{ backgroundColor: '#87d068' }} src={userImg} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
